import { render, staticRenderFns } from "./Importation.vue?vue&type=template&id=3096fd76"
import script from "./Importation.vue?vue&type=script&lang=js"
export * from "./Importation.vue?vue&type=script&lang=js"
import style0 from "./Importation.vue?vue&type=style&index=0&id=3096fd76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports